import { render, staticRenderFns } from "./CourseDoesntHaveBook.vue?vue&type=template&id=e3163554&scoped=true"
import script from "./CourseDoesntHaveBook.vue?vue&type=script&lang=js"
export * from "./CourseDoesntHaveBook.vue?vue&type=script&lang=js"
import style0 from "./CourseDoesntHaveBook.vue?vue&type=style&index=0&id=e3163554&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3163554",
  null
  
)

export default component.exports